// extracted by css-extract-rspack-plugin
module.exports =  {"root":"InfiniteScrollLoader__root___NOkIP","compact":"InfiniteScrollLoader__compact___aAk4c"};